"use client";

import React from "react";
import { useSelector } from "react-redux";

import ImageAtom, { MagnoliaImage } from "@/components/atoms/image/image";
import { RootState } from "@/store/root-reducer";
import { LoginButtonSectionProps } from "@/types/confirmation-types";

import Logo from "../logo-component/logo";

function ImageBannerContent({
  aboutCoverTitle,
  aboutCoverImage,
}: Readonly<LoginButtonSectionProps>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const imageProps: MagnoliaImage | undefined | null =
    typeof aboutCoverImage === "string"
      ? {
          "@id": "",
          "@link": aboutCoverImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : aboutCoverImage;

  if (!attributes)
    return <div data-testid="imagebanner-loading-id">Loading...</div>;

  return (
    <div
      className="flex flex-col gap-spacing-m md:gap-spacing-l "
      data-testid="image-banner-content"
    >
      {imageProps && (
        <div className="relalive">
          {!imageLoaded && (
            <div className="absolute w-full h-full top-0 left-0 z-[3] animate-loading rounded-xl" />
          )}
          <div className={` ${imageLoaded ? "visible" : "invisible"}`}>
            <ImageAtom
              image={imageProps}
              styleClass="rounded-xl absolute inset-0 w-full h-full object-cover transform scale-125 md:scale-100 transition-transform duration-500 z-[1]"
              data-testid="banner-image-testid"
              onLoad={() => setImageLoaded(true)}
            />
          </div>
        </div>
      )}
      <div
        className="absolute inset-0 lg:hidden block"
        style={{
          background:
            "linear-gradient(0deg, rgba(42, 0, 60, 0.00) -8.69%, rgba(112, 0, 162, 0.50) 120.46%, rgba(91, 0, 131, 0.35) 120.46%)",
        }}
      >
        <Logo color="white" size="xl" />
        <h1 className=" font-header-font text-[26px] md:text-[39px] leading-[27.6px] md:leading-[44.85px] text-center md:text-left md:px-[32.5px] text-dark-text-title mt-[45px] md:mt-0">
          {attributes?.organiser?.firstName
            ? attributes?.organiser?.firstName
            : ""}
          ,
          <br /> {aboutCoverTitle}
        </h1>
      </div>
    </div>
  );
}

export default ImageBannerContent;
